import React from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { ArrowLeft, Construction } from 'lucide-react'
import Breadcrumb from '../../components/Common/Breadcrumb'

const TITLE_MAP = {
  'application-parameters': 'Application Parameters',
  'audit': 'Audit',
  'user-changes': 'User Changes',
  'security-updates': 'Security Updates',
  'config-changes': 'Config Changes',
  'data-operations': 'Data Operations',
  'menu-item-master': 'Menu Item Master'
}

const ComingSoon = () => {
  const navigate = useNavigate()
  const { pathname } = useLocation()
  const slug = pathname.split('/').pop()
  const title = TITLE_MAP[slug] || slug?.replace(/-/g, ' ').replace(/\b\w/g, c => c.toUpperCase()) || 'This module'

  return (
    <div className="coming-soon-container" style={{ padding: '24px', maxWidth: 600, margin: '0 auto' }}>
      <Breadcrumb
        items={[
          { label: 'Settings', path: '/settings' },
          { label: title, isCurrent: true }
        ]}
      />
      <div
        style={{
          textAlign: 'center',
          padding: '48px 24px',
          background: 'var(--surface-secondary, #f8f9fa)',
          borderRadius: 12,
          marginTop: 24
        }}
      >
        <Construction size={64} style={{ color: 'var(--primary, #6366f1)', marginBottom: 24 }} />
        <h2 style={{ marginBottom: 12, fontSize: '1.5rem' }}>{title}</h2>
        <p style={{ color: 'var(--text-muted)', marginBottom: 24 }}>
          This feature is under development and will be available soon.
        </p>
        <button
          type="button"
          className="btn btn-primary"
          onClick={() => navigate('/settings')}
          style={{ display: 'inline-flex', alignItems: 'center', gap: 8 }}
        >
          <ArrowLeft size={18} />
          Back to Settings
        </button>
      </div>
    </div>
  )
}

export default ComingSoon
